import { useMemo } from "react";
import { useSearchParams } from "react-router-dom";

import { parseSearchQuery } from "@/utils/searchQuery";

import { SearchConditionType } from "./useSearchCondition";

const useSearchQuery = () => {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    return {
      query: parseSearchQuery(searchParams) as SearchConditionType,
    };
  }, [searchParams]);
};

export default useSearchQuery;
